/* eslint-disable react/forbid-prop-types,import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { WalletsFilter, WalletsList } from '../partials';

export const AccountsContent = ({
  setSelectedWalletType,
  onChangeSearchInput,
  onDepositClick,
  onWithdrawalClick,
  onSendClick,
  onExchangeClick,
  refetchAllWallets,
  selectedWalletType,
  isLoading,
  showEmptyAccountScreen,
  searchInput,
  ledgerAccounts,
  userRegionSettings,
  filteredWallets,
}) => (
  <div>
    <WalletsFilter
      onChangeType={setSelectedWalletType}
      onChangeSearch={onChangeSearchInput}
      selectedTab={selectedWalletType}
    />
    <WalletsList
      selectedWalletType={selectedWalletType}
      onDepositClick={onDepositClick}
      onWithdrawalClick={onWithdrawalClick}
      onSendClick={onSendClick}
      onExchangeClick={onExchangeClick}
      isWalletsLoading={isLoading}
      wallets={filteredWallets}
      ledgerAccounts={ledgerAccounts}
      refetchWallets={refetchAllWallets}
      searchValue={searchInput || ''}
      userRegionSettings={userRegionSettings || {}}
      showEmptyAccounts={showEmptyAccountScreen}
      showNoSearchResultFound={searchInput !== '' && filteredWallets?.length === 0}
    />
  </div>
);

AccountsContent.propTypes = {
  setSelectedWalletType: PropTypes.func.isRequired,
  onChangeSearchInput: PropTypes.func.isRequired,
  onDepositClick: PropTypes.func.isRequired,
  onWithdrawalClick: PropTypes.func.isRequired,
  onSendClick: PropTypes.func.isRequired,
  onExchangeClick: PropTypes.func.isRequired,
  refetchAllWallets: PropTypes.func.isRequired,
  selectedWalletType: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showEmptyAccountScreen: PropTypes.bool.isRequired,
  searchInput: PropTypes.string.isRequired,
  ledgerAccounts: PropTypes.array.isRequired,
  userRegionSettings: PropTypes.array.isRequired,
  filteredWallets: PropTypes.array.isRequired,
};
